import React from 'react';

import { InfoPoints } from '../../../components/custom';
import {
  DraggerSimplified,
  getWildcardTextMaximum,
} from '../../../components/video';
import AttendeePanel from './attendeePanel';
import { ExtendedEvent } from './getData';

interface Props {
  event: ExtendedEvent;
}

const UgcUploadPanel: React.FC<Props> = (props) => {
  const { event } = props;

  const ugcInfoPoints = [
    'Upload at least ' + getWildcardTextMaximum([2, 5], 'video', 'around'),
    `Make sure to record videos in <b>${event.videoMode} orientation</b>`,
    'Your videos are in MP4 or MOV format',
  ];

  return (
    <AttendeePanel heading="Clips Upload Center" className="w-full">
      <div className="flex gap-4 items-center">
        <InfoPoints points={ugcInfoPoints} />

        <div className="w-2/3">
          <DraggerSimplified
            type="video"
            heading="Upload videos (2)"
            isMultiple
            onDrop={() => {}}
          />
        </div>
      </div>
    </AttendeePanel>
  );
};

export default UgcUploadPanel;
